import graphql from 'babel-plugin-relay/macro'
import paths from 'paths'
import { Suspense } from 'react'
import { useLazyLoadQuery } from 'react-relay/hooks'
import { Navigate, useParams } from 'react-router-dom'

import { OrganizationAppIdResolverQuery } from './__generated__/OrganizationAppIdResolverQuery.graphql'
import AppManagementLoader from './AppManagementLoader'

const query = graphql`
  query OrganizationAppIdResolverQuery(
    $organizationSlug: String!
    $appSlug: String!
  ) {
    viewer {
      me {
        id
      }
      app(organizationSlug: $organizationSlug, appSlug: $appSlug) {
        id
      }
    }
  }
`

type OrganizationAppIdResolverParams = {
  organizationSlug: string
  appSlug: string
}

// Resolves an app ID based on an organization and app slug.
const OrganizationAppIdResolver = () => {
  const params = useParams<OrganizationAppIdResolverParams>()

  const { viewer } = useLazyLoadQuery<OrganizationAppIdResolverQuery>(
    query,
    { organizationSlug: params.organizationSlug!, appSlug: params.appSlug! },
    {
      fetchPolicy: 'network-only',
    },
  )

  const appId = viewer.app?.id
  if (!appId) {
    const redirectUrl = `${paths.userApps({
      userId: viewer.me!.id,
    })}?appNotFound=${params.appSlug}`
    return <Navigate to={redirectUrl} replace />
  }

  return (
    <Suspense fallback={null}>
      <AppManagementLoader appId={appId} />
    </Suspense>
  )
}

export default OrganizationAppIdResolver
